"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itauSheetRequestSchema = exports.PaymentItauSheetSchema = exports.ItausheetPaymentType = void 0;
const zod_1 = require("zod");
const string_fns_1 = require("./utils/string.fns");
const back_code_1 = require("./utils/back-code");
var ItausheetPaymentType;
(function (ItausheetPaymentType) {
    ItausheetPaymentType[ItausheetPaymentType["Payment"] = 13] = "Payment";
})(ItausheetPaymentType = exports.ItausheetPaymentType || (exports.ItausheetPaymentType = {}));
const DEFAULT_PAYMENT_TYPE = ItausheetPaymentType.Payment;
const itauSheetContext = zod_1.z.object({
    type: zod_1.z.literal('planilha_itau'),
    data: zod_1.z
        .object({
        payment_type: zod_1.z.nativeEnum(ItausheetPaymentType),
    })
        .optional()
        .default({ payment_type: DEFAULT_PAYMENT_TYPE }),
});
exports.PaymentItauSheetSchema = zod_1.z.object({
    creditor_name: zod_1.z.string().min(1),
    amount: zod_1.z.number().min(0.01),
    cpf_or_cnpj: string_fns_1.cpfCnpjValidator.transform(Number),
    transfer: zod_1.z.object({
        type: zod_1.z.literal('account'),
        bank_code: zod_1.z.string().refine(v => v === back_code_1.BANK_CODES.itau, 'O código do banco é inválido'),
        branch: zod_1.z.coerce.number().min(1, 'O número da agência é inválido'),
        account: zod_1.z.coerce.number().min(1, 'O número da conta é inválido'),
        account_digit: zod_1.z.coerce.number().min(0, 'O dígito da conta é inválido').optional().default(0),
    }),
    payroll_checkout_id: zod_1.z.number().optional(),
});
exports.itauSheetRequestSchema = zod_1.z.object({
    payments: zod_1.z.array(exports.PaymentItauSheetSchema).min(1),
    context: itauSheetContext,
});
